// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"40817553","57":"78825eb7","241":"6548f7ca","455":"f902feb8","977":"240addac"}[chunkId] + ".chunk.js";
};